import LegalPageLayout from './LegalPageLayout';

function TermsOfUse() {
    return <LegalPageLayout nsKey="termsOfUse" />;
}

export default TermsOfUse;
